module.exports = __webpack_public_path__ + "static/img/kj1-8.4204d7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-8.png
// module id = 927
// module chunks = 0